module.exports = __webpack_public_path__ + "img/hb.c69aad28.png";